import { memo } from 'react';
import { Image } from 'src/components/common/Image';

import type { TpLearnMoreItem } from '@features/Stripe/types';
import { FormattedMessage } from '@features/intl';

import classNames from 'classnames';
import styles from './LearnMoreList.module.scss';

type TpLearnMoreListProps = {
  learnMoreList: TpLearnMoreItem[];
  isChecked?: boolean;
  variant?: 'secondary' | 'default' | 'minimal';
};

export const LearnMoreList = memo((props: TpLearnMoreListProps) => {
  const { learnMoreList, variant = 'default' } = props;

  return (
    <div
      className={classNames(styles.learnMoreList, {
        [styles.secondary]: variant === 'secondary',
        [styles.minimal]: variant === 'minimal',
      })}
    >
      {learnMoreList.map(({ icon, title, titleId }) => (
        <div key={icon} className={styles.learnMoreItem}>
          <Image src={icon} alt="" width={32} height={32} />
          <p>
            {titleId ? (
              <FormattedMessage defaultMessage={title} id={titleId} />
            ) : (
              title
            )}
          </p>
        </div>
      ))}
    </div>
  );
});
